/**
 * Binary search in ordered array
 * @param array
 * @param value
 * @returns {number} index
 */
const binarySearch = (array, value) => {
	let low = 0;
	let high = array.length;

	while (low < high) {
		// eslint-disable-next-line no-bitwise
		const mid = (low + high) >>> 1;
		if (array[mid] <= value) low = mid + 1;
		else high = mid;
	}
	return low - 1;
};

export { binarySearch };
